import classNames from "classnames";
import React, { useCallback } from "react";
import { NavDropdown } from "react-bootstrap";

import { Icon } from "@/components/Icon";
import { ThemeOption, useTheme } from "@/stores/ThemeContext";

export interface ThemeSwitcherProps {
  className: string;
}

const themeIconMap = {
  light: "sun-fill",
  dark: "moon-stars-fill",
  auto: "circle-half",
};

export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ className }) => {
  const { themeOption: currentThemeOption, updateThemeOption: setCurrentThemeOption } = useTheme();

  // Event handler to update the theme when the user clicks on a theme toggle
  const onThemeButtonClicked = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const newTheme = e.currentTarget.dataset["theme"] as ThemeOption;
      setCurrentThemeOption(newTheme);
    },
    [setCurrentThemeOption],
  );

  return (
    <NavDropdown className={className} title={<ThemeDropdownTitle theme={currentThemeOption} />} align={"end"}>
      {Object.entries(themeIconMap).map(([themeOption, icon]) => (
        <NavDropdown.Item
          key={themeOption}
          className={classNames("d-flex align-items-center", { active: themeOption === currentThemeOption })}
          onClick={onThemeButtonClicked}
          data-theme={themeOption}
        >
          <Icon icon={icon} className="me-2 opacity-50" />
          {themeOption}
          {themeOption === currentThemeOption && <Icon icon="check2" className="ms-auto" />}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};

const ThemeDropdownTitle: React.FC<{ theme: ThemeOption }> = ({ theme }) => {
  return (
    <>
      <Icon icon={themeIconMap[theme]} />
      <span className="d-lg-none ms-2">Toggle theme</span>
    </>
  );
};
